import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('liquidacao', 'dashboard-fornecedor/configuracao');

const dashboardActions = {
  buscarCamposFiltro: { methods: 'GET', url: `${basePath}/campos/filtro` },
};

export default (resource) => resource(`${basePath}`, {}, dashboardActions);
